import Icon from '../components/Icon.vue'

Icon.register({
  'hand-point-up': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M135.7 0C159.3 0 179.5 20.6 179.5 44.8V144.7C196.5 128.3 229.2 126.3 250.4 150.9 273.3 136.7 303.4 148.8 312.7 167.4 361.9 158.4 384 189.3 384 240 384 242.7 383.8 253.3 383.8 256 384 318 352.7 332.9 345.5 379.7 343.7 391.4 333.6 400 321.8 400H150.3L150.3 400C131.9 400 114.4 389.4 106.4 371.5 93.4 342.6 57.4 276.1 29.1 264 10.9 256.2 0 242.6 0 224 0 189.8 35.1 166.2 66.9 179.9 75.3 183.5 83.6 188.2 91.8 194V44.8C91.8 21.4 112.4 0 135.7 0zM136 416H328C341.3 416 352 426.7 352 440V488C352 501.3 341.3 512 328 512H136C122.7 512 112 501.3 112 488V440C112 426.7 122.7 416 136 416zM304 444C293 444 284 453 284 464S293 484 304 484 324 475 324 464 315 444 304 444z'
      }
    ]
  }
})
